import { type FC } from 'react';
import { PriceIndexOzonOnboarding } from '#features/PriceIndexOzonOnboarding';
import {
    PAGE_TITLE_ABC_ANALYSIS,
    PAGE_TITLE_COLLECTIONS,
    PAGE_TITLE_PRODUCTS,
    PAGE_TITLE_SETTINGS_BADGES,
    PAGE_TITLE_SETTINGS_CHARACTERISTICS,
} from '#shared/lib/constants';
import { renderWithPermission } from '#shared/lib/managerPermissions';
import { useMobileView } from '#shared/lib/platform';
import {
    abcAnalysisRoute,
    badgeRoute,
    badgesRoute,
    characteristicRoute,
    collectionEditCardsActionRoute,
    collectionEditRoute,
    collectionsRoute,
    contextCollectionEditRoute,
    productCardRoute,
    productsRoute,
    productVariantRoute,
    productVariantStocksRoute,
} from '#shared/lib/routes';
import { type SidebarMenuItem } from '../types';

export const COLLECTIONS_MENU_ITEM: SidebarMenuItem = {
    href: collectionsRoute.getUrl(),
    permission: 'content',
    itemId: 'collections',
    routes: [
        collectionsRoute.route,
        collectionEditRoute.route,
        collectionEditCardsActionRoute.route,
        contextCollectionEditRoute.route,
    ],
    label: PAGE_TITLE_COLLECTIONS,
    title: PAGE_TITLE_COLLECTIONS,
};

export const ABC_ANALYSIS_MENU_ITEM: SidebarMenuItem = {
    href: abcAnalysisRoute.getUrl(),
    permission: 'content',
    itemId: 'abc-analysis',
    routes: [abcAnalysisRoute.route],
    label: PAGE_TITLE_ABC_ANALYSIS,
    title: PAGE_TITLE_ABC_ANALYSIS,
};

export const CHARACTERISTICS_MENU_ITEM: SidebarMenuItem = {
    title: PAGE_TITLE_SETTINGS_CHARACTERISTICS,
    permission: 'content',
    routes: [characteristicRoute.route],
    label: PAGE_TITLE_SETTINGS_CHARACTERISTICS,
    href: characteristicRoute.getUrl(),
    itemId: 'characteristics',
};

export const BADGES_MENU_ITEM: SidebarMenuItem = {
    title: PAGE_TITLE_SETTINGS_BADGES,
    permission: 'content',
    routes: [badgesRoute.route, badgeRoute.route],
    label: PAGE_TITLE_SETTINGS_BADGES,
    href: badgesRoute.getUrl(),
    itemId: 'badges',
};

const ProductsMenuTitle: FC = () => {
    const isMobileView = useMobileView();

    if (isMobileView) {
        return <>{PAGE_TITLE_PRODUCTS}</>;
    }

    return (
        renderWithPermission(
            'settings',
            'write',
            <PriceIndexOzonOnboarding>{PAGE_TITLE_PRODUCTS}</PriceIndexOzonOnboarding>
        ) ?? <>{PAGE_TITLE_PRODUCTS}</>
    );
};

export const PRODUCTS_MENU_ITEM: SidebarMenuItem = {
    href: productsRoute.getUrl(),
    permission: 'content',
    iconLabel: '',
    itemId: 'products',
    routes: [productsRoute.route, productCardRoute.route, productVariantRoute.route, productVariantStocksRoute.route],
    label: PAGE_TITLE_PRODUCTS,
    title: <ProductsMenuTitle />,
};
